import { render } from "./TheAdminPatientUpdate.vue?vue&type=template&id=66c003d3&ts=true"
import script from "./TheAdminPatientUpdate.vue?vue&type=script&lang=ts"
export * from "./TheAdminPatientUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__